import { StrategyBuilderFunction, EMPTY_STRATEGY } from './types';
import { addLongCall, addShortPut } from './addOption';
import {
  getDefaultExpiration,
  findClosestStrikePrice,
  getStrikesAtExpiration,
  expirationToDate,
  getPremium,
  getStrategyLegStrikeDirection,
  getStrikeDistance,
} from './utils';

export const longCombo: StrategyBuilderFunction = ({
  chain,
  spot,
  expirationDate,
  expirationKey,
  strikeDirection,
  contractMultiplier = 1,
}) => {
  const strikesAtExpiration = expirationKey
    ? getStrikesAtExpiration(chain, expirationKey)
    : getDefaultExpiration(chain);

  if (
    !strikesAtExpiration ||
    !strikesAtExpiration.e ||
    !strikesAtExpiration.ey ||
    !strikesAtExpiration.em ||
    !strikesAtExpiration.ed
  ) {
    return EMPTY_STRATEGY;
  }

  const expirationDateForOptions =
    expirationDate ||
    expirationToDate(strikesAtExpiration.ey, strikesAtExpiration.em, strikesAtExpiration.ed);
  const expirationKeyForOptions = expirationKey || strikesAtExpiration.e;

  // Choosing the strike price closest to the current spot price
  const putStrikePrice = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: -2 }),
  );
  const callStrikePrice = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: 2 }),
  );

  return {
    optionPositions: [
      // Buy a call option
      addLongCall({
        strike: callStrikePrice,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[callStrikePrice]?.c?.a || 0,
          bid: strikesAtExpiration?.c?.[callStrikePrice]?.c?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'long'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
      // Sell a put option
      addShortPut({
        strike: putStrikePrice,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[putStrikePrice]?.p?.a || 0,
          bid: strikesAtExpiration?.c?.[putStrikePrice]?.p?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
    ],
    stockPositions: [],
  };
};
